module.exports = __webpack_public_path__ + "img/informacao-campo.1a528202.svg";